import Header from "@commons/header";
import Tab from "@components/tabs";
import SectionTitleTable from "./Table";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import { Module } from "@apis/index";
import { RootState } from "@store/index";

const SectionTitleList = () => {
  const { data: modules = [] } = useSelector((state: RootState) => state.modules);

  useEffect(() => {
    Module.list({ state: "modules", params: { isActive: true } });
  }, []);

  const items = modules.map((module) => ({
    label: module.name,
    component: SectionTitleTable,
    props: { moduleId: module.id },
  }));

  return (
    <>
      <Header title="All Section Titles" />
      <Tab items={items} fitContent paramKey="section_module" />
    </>
  );
};

export default SectionTitleList;
